module.exports = __webpack_public_path__ + "static/media/Leopard Family Eating Pray [REDUCED].981e6dad.m4v";